import { render, staticRenderFns } from "./Nested.vue?vue&type=template&id=4d57fbd6&"
import script from "./Nested.vue?vue&type=script&lang=ts&"
export * from "./Nested.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports